export default __webpack_public_path__ + "static/media/instagram-logo.55cf114b.svg";